import { useNavigate } from 'react-router-dom'
import AdminSightingsSection from '../../components/admin/AdminSightingsSection'
import AdminHeader from '../../components/admin/AdminHeader'

export default function SightingsPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gray-50">
      <AdminHeader />
      <div className="py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <AdminSightingsSection onBack={() => navigate('/admin')} />
        </div>
      </div>
    </div>
  )
}
